import React from "react";
import Layout from "../components/Layout";
import SEOHead from "../components/SEOHead";
import PageHeader from "../components/PageHeader";
import DemoBadge from "../components/DemoBadge";

const CASES = [
  { name: "Mid-size City — Drainage reallocation",
    summary: "A 48k-resident city identified a 34% administrative growth gap while drainage capital projects were 53% over original budget.",
    outcome: "Preliminary analysis surfaced $1.1M of decision-support reallocation into stormwater drainage.",
    tag: "Municipal · Infrastructure" },
  { name: "County Government — Vendor concentration",
    summary: "A mid-size county flagged single-vendor concentration at 28.4% of active contracts.",
    outcome: "Risk indicator triggered review; procurement diversification roadmap produced in 3 weeks.",
    tag: "County · Vendor Risk" },
  { name: "Data Center — CyberWater pilot",
    summary: "A 12MW hyperscale facility integrated AWG, cooling-loop, and PLC telemetry with CyberWater.",
    outcome: "Zero-trust device identity + dual-approval on pump shutdown implemented in 6 weeks.",
    tag: "Data Center · CyberWater" },
  { name: "School District — Cyber readiness",
    summary: "A 15k-student district assessed cyber posture and deferred IT modernization exposure.",
    outcome: "Identified $220k gap and seeded a cyber reserve aligned with peer benchmarks.",
    tag: "Education · Cyber" },
];

const CaseStudies = () => (
  <Layout>
    <SEOHead title="Case Studies | AuditIQ" path="/case-studies"
      description="AuditIQ case studies across municipal budget analysis, vendor concentration, data-center CyberWater, and school-district cyber readiness." />
    <PageHeader eyebrow="Case Studies" demo
      title="Real-shape public-sector scenarios."
      subtitle="Representative engagements using AuditIQ and CyberWater. Names and numbers here are representative of scenarios used in demo mode." />
    <section className="max-w-[1400px] mx-auto px-6 py-16 grid md:grid-cols-2 gap-6">
      {CASES.map(c => (
        <div key={c.name} className="panel-elev p-7">
          <div className="text-[10px] uppercase tracking-[0.24em] text-gold">{c.tag}</div>
          <h3 className="font-display text-xl text-cream mt-2">{c.name}</h3>
          <p className="text-sm text-cream-dim mt-3 leading-relaxed">{c.summary}</p>
          <div className="gold-rule my-4" />
          <p className="text-sm text-cream"><strong className="text-gold">Outcome:</strong> {c.outcome}</p>
          <div className="mt-4"><DemoBadge label="Representative Scenario" /></div>
        </div>
      ))}
    </section>
  </Layout>
);

export default CaseStudies;
